import image1 from "../images/HeroImages/1.jpg";
import image2 from "../images/HeroImages/2.jpg";
import image3 from "../images/HeroImages/3.jpg";

export default [image1, image2, image3];
